import { render } from "./MyListFolderPage.vue?vue&type=template&id=91d096d8&scoped=true&ts=true"
import script from "./MyListFolderPage.vue?vue&type=script&lang=ts"
export * from "./MyListFolderPage.vue?vue&type=script&lang=ts"

import "./MyListFolderPage.vue?vue&type=style&index=0&id=91d096d8&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91d096d8"]])

export default __exports__